import { ToolOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";

import { useAppSelector } from "@/store/hooks";

const { Paragraph, Title } = Typography;

export const MaintenanceOverlay = () => {
  const maintenance = useAppSelector((state) => state.app.maintenance);

  if (!maintenance.active) {
    return null;
  }

  return (
    <div className="maintenance-overlay" role="alertdialog" aria-modal="true">
      <div className="maintenance-overlay__content">
        <div className="maintenance-overlay__icon" aria-hidden="true">
          <ToolOutlined />
        </div>
        <Title level={2}>Đang bảo trì hệ thống</Title>
        <Paragraph className="maintenance-overlay__message">
          {maintenance.message}
        </Paragraph>
        <Button
          size="large"
          type="primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          Thử lại
        </Button>
      </div>
    </div>
  );
};
